import * as IF from "infrontjs";
import template from './template.html';

class RoutineDynamic extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'options', 'value' ];
    }

    get options()
    {
        let opts = this.getAttribute( 'options' );
        if ( opts && opts.length > 0 )
        {
            opts = JSON.parse( opts );
            if ( !opts && 0 === opts.length )
            {
                opts = [];
            }
        }
        return opts;
    }

    constructor()
    {
        super();
        this._isConnected = false;
        this._isRendered = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.namePattern = this.getAttribute( 'name' );
            this.render();

            // This is always checked
            this.root.setAttribute( 'checked', true );

            this.root.querySelector( '[data-id="routine-dynamic-selection"]' ).addEventListener( 'click', () =>
            {
                let selectionHtml = '';
                for ( let oi = 0; oi < this.options.length; oi++ )
                {
                    selectionHtml += `<div class="row" style="margin-bottom: 6px"><div class="col-12">`;
                    selectionHtml += `<button type="button" data-type="dynamicValue" data-value="${this.options[ oi ]}" class="btn btn-block btn-m rounded-xs text-uppercase shadow-s bg-primary mb-2">${this.options[ oi ]}</button>`;
                    selectionHtml += `</div></div>`;
                }

                const drContainer = this.app.gui.getDynamicRoutineModalContainer();
                drContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                {
                    drContainer.querySelector( '[data-type="dynamicValue"]' ).removeEventListeners( 'click' );
                    drContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                    this.app.gui.hideDynamicRoutineModalContainer();
                });

                this.app.gui.showDynamicRoutineModalContainer( selectionHtml );

                drContainer.querySelectorAll( '[data-type="dynamicValue"]' ).forEach( btn =>
                {
                    btn.addEventListener( 'click', () => {
                        this.root.setAttribute( 'value', btn.getAttribute( 'data-value' ) );
                        drContainer.querySelector( '[data-type="modal-closer"]' ).click();
                    });
                });
            });

            this._isConnected = true;
        }
    }

    _onFrequenceSelection( times )
    {
        const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
        wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( (btn) =>
        {
            btn.removeEventListeners( 'click' );
        });
        this.setAttribute( 'weekly-frequence', times );
        this.app.gui.hideFrequenceModal();
    }

    disconnectedCallback()
    {}

    attributeChangedCallback( name, oldVal, newVal )
    {
        if ( this._isConnected )
        {
            if ( "value" === name && this._isRendered === true )
            {
                this.root.querySelector( '[data-id="dynamic-value"]' ).innerHTML = newVal;
                const name = this.namePattern.replace( "__WT__", newVal );
                this.setAttribute( 'name', name );
            }
            else if ( "name" === name )
            {
                // Do nothing
            }
            else
            {
                this.render();
            }
        }
    }

    render()
    {
        let selectedValue = this.getAttribute( 'value' );
        if ( !selectedValue && this.options.length > 0 )
        {
            selectedValue = this.options[ 0 ];
            const name = this.namePattern.replace( "__WT__", selectedValue );
            this.setAttribute( 'name', name );
        }

        let icon = this.hasAttribute( 'icon' ) ? this.getAttribute( 'icon' ) : null;

        if ( icon && icon.length <= 0)
        {
            icon = null;
        }

        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                question : this.getAttribute( 'question' ),
                value: selectedValue,
                icon : icon
            }
        );

        this._isRendered = true;
    }

}

customElements.define('routine-dynamic', RoutineDynamic );
